// api calls

// import { useSelector, useDispatch } from "react-redux";
import * as MyAPI from './MyAPI'
import * as UserActions from '../actions/UserActions'

// let dispatch = useDispatch();

// _checkSubscriptionStatus
export const checkSubscriptionStatus = async (login_token) => {

  try {

    // logout on server
    let _results = await MyAPI.checkSubscriptionStatus({
      login_token: login_token,
    })

    if (_results.status === "error") {
      throw Error(_results.message)
    }
    
    let subscription_status = "incomplete"
    if (_results.subscription_status) {
      subscription_status = _results.subscription_status
    }

    return {
      subscription_status: subscription_status,
      card_info: _results.card_info
    }
    // return subscription_status

  } catch (err) {
    console.log("err: ", err)
    throw Error(err.message)
  }
}
